var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDownCc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7585 9.76804L12.527 16.3136C12.2486 16.5621 11.8311 16.5621 11.5525 16.3136L4.24043 9.76804C3.94226 9.45894 3.91817 9.04076 4.18635 8.74076C4.47179 8.42712 4.93177 8.43166 5.21495 8.68621L11.9997 14.7954L18.7858 8.68621C19.0856 8.41907 19.5445 8.44253 19.814 8.74021C20.0813 9.04076 20.0585 9.45894 19.7585 9.76804Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDownCc);
export default __webpack_public_path__ + "static/media/angle-down-cc.72a67a7984dc774cff3d31a5c01c09d8.svg";
export { ForwardRef as ReactComponent };